// add the fonts that we need for heading and body
import "@fontsource/inter";
import "@fontsource/nunito";
// enable auto resizing in the parent iframe
// https://github.com/davidjbradshaw/iframe-resizer
import "iframe-resizer/js/iframeResizer.contentWindow";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import App from "./App";
import { Error } from "./components/errors/Error";
import { Error404 } from "./components/errors/Error404";
import "./index.css";
import certificateLoader from "./loaders/certificate.loader";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";

const router = createBrowserRouter([
  {
    path: "*",
    element: <Error404 />,
  },
  {
    path: "/:certificateId",
    element: <App />,
    loader: certificateLoader,
    // if the loader throws an exception, show the Error component
    errorElement: <Error />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
